var t,n;!function(t){t.TEXT1="text1",t.TEXT2="text2"}(t||(t={})),function(t){t.BOLD="bold",t.MEDIUM="medium",t.NORMAL="normal"}(n||(n={}));export{t as TextType,n as TextWeight};
//# sourceMappingURL=TextConstants.js.map
